/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { CircularProgress, Paper, Theme } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreator } from '../services/AuthServices';

const styles = (theme: Theme) => ({
    progress: {
        margin: ((theme && (theme as any).spacing) ? (theme as any).spacing(2) : 16)
    },
    progressWrap: {
        textAlign: 'center' as const,
        marginTop: '20vh'
    }
});

interface Props {
    AuthorizeUser: Function,
    classes?: any,
    userNotFound: any,
}

interface State {
}

class SigninCallBack extends React.Component<Props, State> {

    constructor(props: any) {
        super(props);
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const code = params.get('code');
        const state = params.get('state');
        if (code) {
            this.props.AuthorizeUser(code, state);
        }
    }

    render() {
        const { classes, userNotFound } = this.props;
        return (
            <div>

                {userNotFound ?
                    <Paper style={{ borderRadius: '0px', textAlign: 'center' as const, padding: '20px', }}>
                        We do not have your contact records in our system. Please email repair_services@trimble.com to have your contact records added.
                    </Paper>
                    :
                    <div className={classes.progressWrap}>
                        <CircularProgress className={classes.progress} color="secondary" />
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    state: state.authService,
    data: state.authService.data,
    userNotFound: state.authService.userNotFound,
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreator, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(withStyles(styles, { withTheme: true })(SigninCallBack));
